import { PageHero } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { borderRadius, color, layoutTokens, spacing } from '../styles/tokens.stylex';
import { Breadcrumbs, Crumb } from './breadcrumbs';
import { Button } from './Buttons';
import { Action, ActionButtons } from './Buttons/ActionButtons';
import { CalloutCard, CalloutCardDataType } from './CalloutCard';
import { FullWidthMap } from './FullWidthMap';
import { PageSection } from './PageSection';
import { ReviewStatement } from './ReviewStatement';
import { SectionHeading, SectionHeadingProps } from './SectionHeading';
import { UiIcon } from './svg/UiIcon';
interface HeroProps {
  data: PageHero;
  breadcrumbs?: Crumb[];
}
export function Hero({
  data,
  breadcrumbs
}: HeroProps) {
  const heading = data ? <SectionHeading data={data?.sectionHeadings as SectionHeadingProps['data']} headingType="hero" styles={data.heroType === 'article' && sx.articleColumn} /> : null;
  return data ? <PageSection styles={data.heroType === 'article' && sx.articleHeadingWrapper}>
      {(data.heroType === 'landing' || data.heroType === 'map') && heading}
      {data.heroType === 'article' && heading}
      {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <div {...{
      0: {},
      4: {
        className: "x78zum5 x1a02dak x1qjc9v5 x1mhrlx8 x12h1iku"
      },
      2: {
        className: "x8hhl5t"
      },
      6: {
        className: "x78zum5 x1qjc9v5 x1mhrlx8 x12h1iku x8hhl5t"
      },
      1: {
        className: "xm3ov88"
      },
      5: {
        className: "x78zum5 x1a02dak x1qjc9v5 x1mhrlx8 x12h1iku xm3ov88"
      },
      3: {
        className: "x8hhl5t xm3ov88"
      },
      7: {
        className: "x78zum5 x1qjc9v5 x1mhrlx8 x12h1iku x8hhl5t xm3ov88"
      }
    }[!!(data.heroType !== 'article') << 2 | !!(data.heroType === 'standard') << 1 | !!(data.heroType === 'article') << 0]}>
        {data.heroType === 'standard' && <div className="x98rzlu x5isd7a x1esio5o x145hb71 xrvj5dj x1mhrlx8 x10ukxgv">
            {heading}
            {data.ctas && data.ctas?.length && <div className="xeq5yr9">
                <ActionButtons actions={data.ctas as Action[]} args={{
            componentName: data.__typename
          }} />
              </div>}
            {data.reviewStatement && <ReviewStatement data={data} />}
          </div>}
        {data.video && <div className="xrhgmaw x98rzlu x1bhwmg6 xlmjrz9 x193iq5w x712feu x186iv6y x1o5z2k8 xrvj5dj x11x033 x1n2onr6 xb3r6kr" data-tina-field={tinaField(data, 'video')}>
            <Image className="xl1xv1r" alt={data.video?.alt as string} src={data.video?.image as string} fill sizes="420px, (max-width: 768px) 100vw (max-width: 1200px) 50vw, 33vw" priority />
            {data.video?.videoId && <Button iconOnly={<UiIcon icon="Play" />} variant="media-action" size="large" controlled>
                Play Video
              </Button>}
          </div>}
        {data.heroType === 'landing' && data.calloutCard && <CalloutCard data={data.calloutCard as CalloutCardDataType} />}
      </div>
      {data.heroType === 'map' && <FullWidthMap data={data.googleMap ?? {}} />}
      {data.reviewStatement && data.heroType !== 'standard' && <ReviewStatement data={data} />}
    </PageSection> : null;
}
const sx = {
  articleHeadingWrapper: {
    kanfag: "xgu5lr5",
    k9g6sI: "x12h1iku",
    k1xSpc: "xrvj5dj",
    kUOVxO: "x1ypdn0p",
    kzqmXN: "xtpsss9",
    kumcoG: "x1pt1dkn",
    $$css: true
  },
  articleColumn: {
    kBCFzs: "xm3ov88",
    $$css: true
  }
};